import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterDMLOAIXE({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    name: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.name) {
      condition.name = {
        $regex: filter.name?.split(" ").join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Tên loại xe"
        placeholder="Tìm tên loại xe"
        value={filter.name}
        onSearch={(val) => setFilter({ ...filter, name: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMLOAIXE;
